// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as DateTime$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getColumnsSchema(msisdn, workspace_dispatch) {
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Week"
            },
            accessor: (function (earning) {
                return {
                        TAG: /* ActionButton */3,
                        _0: DateTime$Catalyst.toString("Do MMM", earning.startDate) + (" - " + DateTime$Catalyst.toString("Do MMM", earning.endDate)),
                        _1: (function (param) {
                            return Curry._2(workspace_dispatch.addTab, {
                                        TAG: /* DriverWeeklyEarningDetails */19,
                                        _0: msisdn,
                                        _1: earning.startDate
                                      }, false);
                          })
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Total Earnings"
              },
              accessor: (function (earning) {
                  return {
                          TAG: /* Text */0,
                          _0: CountryConfig.getSymbol(country) + earning.totalEarnings.toString()
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Total Orders"
                },
                accessor: (function (earning) {
                    return {
                            TAG: /* Text */0,
                            _0: String(earning.totalTrips)
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

function getView(weeklyEarnings, workspace_dispatch) {
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: weeklyEarnings,
              children: (function (earnings) {
                  return React.createElement(CardComponent$Catalyst.make, {
                              children: React.createElement(TableComponent$Catalyst.make, {
                                    columns: getColumnsSchema(earnings.msisdn, workspace_dispatch),
                                    rowData: ReasonReactUtils$Catalyst.sliceList(earnings.earningSummaries, undefined, 5),
                                    className: "order-table"
                                  })
                            });
                })
            });
}

export {
  getColumnsSchema ,
  getView ,
  
}
/* react Not a pure module */
